<template>
    <v-row>
        <v-col cols="12">
            <v-stepper v-if="stepWaiver && stepWaiver > 0" v-model="stepWaiver" non-linear>
                <div class="overflow-x-auto pa-1" ref="overflowStep">
                    <v-stepper-header style="width: max-content; min-width: 100%;">
                    <template v-for="(item, i) in stepByStep">
                        <v-stepper-step
                                :ref="`stepHeader${i}`"
                            :complete="stepWaiver > (i + 1)"
                            :key="`sh-${item.step}`"
                            :step="i + 1" :color="`${buttonColor}`"
                        >{{ item.type }}</v-stepper-step>
                        <v-divider :key="item.step" v-if="item.step < stepByStep.length"></v-divider>
                    </template>
                </v-stepper-header>
                </div>

                <v-stepper-items>
                    <v-stepper-content v-for="(item, j) in stepByStep" :step="j + 1" :key="`sc-${item.step}`" class="pa-sm-6 px-0">
                        
                        <v-row v-if="item.bandSign == 'Confirm'" no-gutters>
                            <v-col cols="12" sm="8" class="mx-auto">
                                <p class="text-center text-h6">
                                    {{$t("eventWaiver.title_pre_waiver_minor_1", {
                                        firstName: item.participantName,
                                        lastName: item.participantLastname
                                    })}}
                                </p>
                                <p class="text-center">
                                    ({{$t("eventWaiver.text_pre_waiver_minor_2")}})
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="6" class="d-flex">
                                        <v-btn :color="buttonColor" class="ml-auto white--text" @click="goYes(item)">
                                            {{$t("common.yes")}}
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn :color="buttonColor" class="white--text" @click="goNo">
                                            {{$t("common.no")}}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="8" class="mx-auto my-4" v-if="bandMinor == 'No'">
                                <WarningAlert>
                                    {{$t("eventWaiver.text_alert_minor_1", {
                                        firstName: waiverItemIndex ? waiverItemIndex.signatoryName : "",
                                        lastName: waiverItemIndex ? waiverItemIndex.signatoryLastname : ""
                                    })}} <br />
                                    {{$t("eventWaiver.text_alert_minor_2")}}
                                </WarningAlert>
                            </v-col>
                        </v-row>
                        <v-row v-else no-gutters>
                            <v-col cols="12">
                                <Waiver
                                    v-if="userStore.id == item.signUserId"
                                    :ref="`waiverMinor${item.step}`"
                                    :peopleMinor="{
                                        firstName: item.participantName,
                                        lastName: item.participantLastname,
                                        gender: item.participantGender,
                                        dateOfBirth: item.participantDateOfBirth
                                    }"
                                    :peopleSignatory="userStore"
                                    :type="item.bandType"
                                    :viewBtnNext="true"
                                    @showSnackBar="({msg, color}) => $emit('showSnackBar', {msg, color})"
                                    @nextSignItem="next(item)"
                                    @backWaiver="backWaiver"
                                    :viewBtnBack="j > 0"
                                    :waiver="item"
                                    :btnNextBottom=" item.step == stepByStep.length ? $t('common.save') : $t('common.next')"
                                />
                                <v-row v-else no-gutters>
                                    <v-col cols="12" sm="8" class="mx-auto pa-6">
                                            <v-row>
                                                <v-col cols="12" md="8" sm="10" class="mx-auto">
                                                    <p class="text-h6">
                                                        {{$t("eventWaiver.title_send_email")}}
                                                    </p>
                                                    <p>({{$t("eventWaiver.description_1_send_email", {firstName: item.participantName, lastName: item.participantLastname})}})</p>
                                                    <p>{{$t("eventWaiver.description_2_send_email", {email: item.signatoryEmail})}}</p>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="8" sm="10" class="mx-auto">
                                                    <v-btn
                                                        :color="`${buttonColor}`"
                                                        class="btn text--white btn-small"
                                                        @click="sendWaiver(item)"
                                                        :loading="registerEmailLoading"
                                                    >
                                                        {{$t('eventWaiver.send_to_waiver', {firstName: item.participantName, lastName: item.participantLastname})}}
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row outlined v-if="item.validateFormEmail" class="pa-sm-4 px-0 mt-8">
                                                <v-col>
                                                    <p class="ml-sm-4 ml-0">
                                                        {{$t("common.waiver_link")}}: <a @click="openWaiver(`${livelapsLink}${item.waiverLink}`)">{{`${livelapsLink}${item.waiverLink}`}}</a>
                                                    </p>
                                                </v-col>
                                            </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="ml-1 mr-1">
                            <v-col md="6" class="text-left">
                                <v-btn
                                    :color="`${buttonColor}`"
                                    class="btn text--white"
                                    @click="back(item)"
                                >{{ $t("common.prev") }}</v-btn>
                            </v-col>
                            <v-col md="6" class="text-right">
                                <v-btn
                                    v-if="item.bandSign != 'Confirm'"
                                    :color="`${buttonColor}`"
                                    class="btn text--white"
                                    @click="next(item)"
                                >{{ item.step == stepByStep.length ? $t("common.save") : $t("common.next") }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
            <v-row v-else>
                <v-col cols="12">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white ml-4"
                        @click="$emit('backStep')"
                    >{{ $t("common.prev") }}</v-btn>
                </v-col>
                <v-col cols="12">
                    <WarningAlert>
                        {{$t("eventWaiver.not_waiver_signed")}}
                    </WarningAlert>
        </v-col>
            </v-row>
        </v-col>
        <v-dialog v-model="dialogWarningWaiver" max-width="900px">
            <v-card>
                <v-card-title>{{$t("common.warning")}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text--primary">
                    {{$t("eventWaiver.warning_open_waiver")}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="buttonColor" @click="dialogWarningWaiver = false" class="white--text mx-1">{{$t("common.cancel")}}</v-btn>
                    <v-btn :color="buttonColor" class="white--text mx-1" @click="confirmOpenWaiver()">
                        {{$t("common.open")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import {
    VRow, VCol, VBtn, VStepper, VStepperHeader, VStepperStep, VDivider, VStepperItems, VStepperContent, 
    VDialog, VCardTitle, VCardText, VCardActions, VCard, VSpacer
} from 'vuetify/lib';
import Waiver from "@/components/waiver/WaiverTemplate";
import { mapState } from "vuex";
import axios from "axios";
import EventWaiverService from "@/services/EventWaiverService";
import WarningAlert from '@/components/alert/WarningAlert.vue';

export default {
    components: {
        VRow, VCol, VBtn, VStepper, VStepperHeader, VStepperStep, VDivider, VStepperItems, VStepperContent,
        Waiver,
        VDialog, VCardTitle, VCardText, VCardActions, VCard, VSpacer,
        WarningAlert
    },
    props: {
        eventsPeoplesList: Array,
        currentIp: { type: String, default: "" },
        waivers: Array,
        listRegisters: Array,
        peoplesSelected: Array
    },
    data() {
        return {
            buttonColor: "#000",
            eventsPeoplesListWaiver: [],
            bandMinor: false,
            bandSign: "Confirm",
            waiverList: [],
            index: 0,
            bandApprove: false,
            stepWaiver: null,
            registerEmailLoading: false,
            validateFormEmailSpectator: false,
            bandSendEmail: false,
            dialogWarningWaiver: false,
            waiverLinkOpen: "",
            stepWaivers: [],
            stepByStep: [],
            waiversPrevius: []
        }
    },
    computed: {
        eventsPeoplesItemWaiver() {
            let _item = false;
            this.eventsPeoplesList.forEach((item) => {
                item.peopleItems.forEach((item1) => {
                    const _item = this.eventsPeoplesListWaiver.find((item2) => {
                        return item2.id == item1.id && item2.event.id == item.id;
                    });
                    if(!_item) {
                        this.eventsPeoplesListWaiver.push({
                            ...item1,
                            waiverSignatory: false,
                            event: item
                        });
                    }
                });
            });
            _item = this.eventsPeoplesListWaiver.find((el) => !el.waiverSignatory);
            return _item ? _item : false;
        },
        ...mapState({
            userStore: (state) => state.session.user,
            livelapsLink: (state) => state.env.get('VUE_APP_LIVELAPS_HOST')
        }),
        waiverItemIndex() {
            this.waivers.forEach((el) => {
                const birthdayCurrent = el.participantDateOfBirth;
                let band = false;
                if(birthdayCurrent) {
                    if(el.ageTarget == "Adult")
                        band = true
                }
                if(this.userStore.id != el.fkUserId && band) {
                    const item = this.waiverList.find((el1) => {
                        return el.id == el1.id;
                    });
                    if(!item) {
                        this.waiverList.push({
                            ...el,
                            statusReview: el.waiverStatus == "Signed"
                        });
                    }
                }
            });
            if(this.index >= 0 && this.index < this.waiverList.length) {
                return this.waiverList[this.index];
            }
            return false;
        },
        peopleMinor() {
            let birthday = this.waiverItemIndex.participantDateOfBirth.split(' ');
            birthday = birthday.length > 0 ? birthday[0] : this.waiverItemIndex.participantDateOfBirth;
            return {
                firstName: this.waiverItemIndex ? this.waiverItemIndex.participantName : "",
                lastName: this.waiverItemIndex ? this.waiverItemIndex.participantLastname : "",
                gender: this.waiverItemIndex ? this.waiverItemIndex.participantGender : "",
                dateOfBirth: birthday ? birthday : ""
            };
        },
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {},
    methods: {
        next(item) {
            if(this.$refs[`waiverMinor${item.step}`] && Array.isArray(this.$refs[`waiverMinor${item.step}`]) && this.$refs[`waiverMinor${item.step}`].length > 0) {
                const band = this.$refs[`waiverMinor${item.step}`][0].nextSign();
                if(!band) {
                    this.$emit('showSnackBar', { msg: this.$t("eventWaiver.invalid_step_4"), color: "error" });
                    return;
                }
                this.nextSignItem(item);
            } else {
                if(item.bandSendEmail) {
                    if(this.stepWaiver < this.stepByStep.length) {
                        this.stepWaiver++;
                    } else {
                        this.$emit('nextStep');
                    }
                } else {
                    this.$emit('showSnackBar', { msg: this.$t("eventWaiver.send_email_other_adult"), color: "error" });
                }
            }
        },
        back(item) {
            if(item.step == 1) {
                this.$emit('backStep');
            } else if(item.step > 1) {
                this.stepWaiver--;
            }
        },
        goYes(item) {
            this.bandMinor = 'Yes';
            item.bandSign = 'Sign';
        },
        goNo() {
            this.bandMinor = 'No';
        },
        async nextSignItem(item) {
            if(item.waiverStatus != 'Signed') {
                const data = new FormData();
                data.append("eventWaiverSignedId", item.id);
                const waiverForm = this.$refs[`waiverMinor${item.step}`][0];
                data.append("iAgree", waiverForm.timeIAgree);
                data.append("isCertify", waiverForm.timeIsCorrect || waiverForm.timeIsCorrectMinor);
                data.append("isConsent", waiverForm.timeIsConsent);
                data.append("signature", waiverForm.signature);
                if(waiverForm.isPictureRequired) {
                    data.append("selfie", waiverForm.selfie);
                }
                data.append("waiverStatus", "Signed");
                data.append("ipAddress", this.currentIp);
                data.append("isNegligence", waiverForm.timeIsNegligence);
                data.append("isBoundParticipant", waiverForm.timeIsBoundParticipant);
                data.append("isBoundParent", waiverForm.timeIsBoundParent);
                data.append("isMinor", waiverForm.type === 'Minor' ? 1 : 0);
                data.append("languageCode", waiverForm.language);
                data.append("isAgreedText", waiverForm.timeIAgreeLabel || "");
                data.append("isNegligenceText", waiverForm.timeIsNegligenceLabel || "");
                data.append("isCertifyText", waiverForm.timeIsCorrectLabel || "");
                data.append("isCertifyMinorText", waiverForm.timeIsCorrectMinorLabel || "");
                data.append("isBoundParticipantText", waiverForm.timeIsBoundParticipantLabel || "");
                data.append("isBoundParentText", waiverForm.timeIsBoundParentLabel || "");
                data.append("isConsentText", waiverForm.timeIsConsentLabel || "");
                data.append("voluntarilyText", waiverForm.$t("eventWaiver.voluntarily_text", waiverForm.language));
                data.append("negligenceText", waiverForm.negligenceParagraph || "");
                data.append("boundAgreementText", waiverForm.boundAgreementParagraph || "");
                let axiosConfig = {
                    headers: { "content-type": "multipart/form-data" },
                };
                const response = await axios.put(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/waivers/saveSignature`, data, axiosConfig);
                if(response.data.success) {
                    item.statusReview = true;
                    item.isAgreedChk = response.data.message.isAgreedChk;
                    item.isElectronicConsentChk = response.data.message.isElectronicConsentChk;
                    item.isCertifyChk = response.data.message.isCertifyChk;
                    item.signatureImage = response.data.message.signatureImage;
                    if(waiverForm.isPictureRequired) item.selfie = response.data.message.signatoryPicture;
                    item.waiverStatus = response.data.message.waiverStatus;
                    if(this.stepWaiver < this.stepByStep.length) {
                        this.stepWaiver++;
                    } else {
                        this.$emit('nextStep');
                    }
                } else if(Array.isArray(response.data.message) && response.data.message.length > 0) {
                    this.$emit('showSnackBar', { msg: this.$t("eventWaiver." + response.data.message[0]), color: "error" });
                    return;
                } else {
                    this.$emit('showSnackBar', { msg: this.$t("common.error_general"), color: "error" });
                    return;
                }
            } else {
                this.stepWaiver++;
            }

        },
        backWaiver() {
            if(this.stepWaiver > 0) this.stepWaiver--;
        },
        async sendWaiver(item) {
            this.registerEmailLoading = true;
            const data = {
                email: item.signatoryEmail,
                waiverId: item.id
            };
            EventWaiverService.sendWaiver(data).then((response) => {
                if(response.data.success) {
                    this.registerEmailLoading = false;
                    item.validateFormEmail = true;
                    item.bandSendEmail = true;
                } else {
                    this.registerEmailLoading = false;
                }
            });
        },
        openWaiver(link) {
            this.dialogWarningWaiver = true;
            this.waiverLinkOpen = link;
        },
        confirmOpenWaiver() {
            window.open(this.waiverLinkOpen, '_blank');
        },
        loadWaivers() {
            let arrayWaivers = [];
            let i = 1;
            this.peoplesSelected.forEach((people) => {
                this.waivers.forEach((item) => {
                    if(people.userId == item.userId) {
                let type = "Waiver";
                let bandType = "Waiver";
                        const birthdayCurrent = item.participantDateOfBirth;
                if(birthdayCurrent) {
                            if(item.ageTarget == "Adult") {
                        type = this.$t("eventWaiver.adult_waiver");
                        bandType = 'Adult';
                    } else {
                        type = this.$t("eventWaiver.minor_waiver");
                        bandType = 'Minor';
                    }
                } else {
                    type = this.$t("eventWaiver.adult_waiver");
                    bandType = 'Adult';
                }
                        if(!item.bandSign) item.bandSign = bandType == 'Minor' ? 'Confirm' : 'Sign';
                        arrayWaivers.push( {
                            ...item,
                            step: i,
                    type,
                    bandType,
                    bandSign: bandType == 'Minor' ? 'Confirm' : 'Sign',
                    validateFormEmail: false,
                    bandSendEmail: false
            });
                        i++;
                    }
                });
            });
            this.stepByStep = arrayWaivers;
        }
    },
    watch: {
        waiverItemIndex(val) {
            this.bandSign = 'Confirm';
            if(!val) {
                this.$emit("nextStep");
            }
        },
        stepByStep(val) {
            if(val.length > 0 && !this.stepWaiver) {
                this.stepWaiver = 1;
            }
        },
        waivers(val) {
            val.forEach((item) => {
                const find = this.waiversPrevius.find((el) => {
                    return el.id == item.id;
                });
                if(find === undefined) {
                    this.waiversPrevius.push(item);
            }
            });
            this.loadWaivers();
        }
    }
}
</script>

<style lang="scss">
@media (max-width: 959px) {
    .btn-small {
        display: block;
        max-width: 100%;
        min-height: 36px;
        height: auto;
        white-space: normal;
    }
}
</style>